// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__myEhF","svg":"Loader_svg__gKnMF","rotate":"Loader_rotate__SVGDU","circle":"Loader_circle__DzuXv","dash":"Loader_dash__9kI+1"};